// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_Tlr","cls2":"TranslationModal-cls2_Iek TranslationModal-cls1_Tlr"};